import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FontIcon from 'components/FontIcon';
import classes from './ProductFilterA.module.scss';

class ProductFilterA extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showMore: false,
    };

    this.toggleShowMore = this.toggleShowMore.bind(this);
  }

  toggleShowMore = () => {
    this.setState((prev) => ({ showMore: !prev.showMore }));
  }

  render() {
    const {
      items = {},
      selectedItems = [],
      onFilterItems,
      category,
      title,
      showMoreItems = 4,
    } = this.props;

    const { showMore } = this.state;

    return (
      <div className={classes.filterContainer}>
        {title && <div className={classes.filterTitle}>{title}</div>}
        {Object.keys(items).map((i, idx) => {
          const disabled = !items[i] && selectedItems.indexOf(i) === -1;
          return ((!showMore && idx < showMoreItems) || showMore) &&
            <div
              className={classes.filterItemContainer}
              key={i}
            >
              <label
                htmlFor={`${i}-filter`}
                className={
                  classNames(
                    classes.inputLabel,
                    {
                      [classes.filterItemContainerSelected]: selectedItems.indexOf(i) !== -1,
                      [classes.filterItemContainerDisabled]: disabled,
                    },
                  )
                }
              >
                <input
                  id={`${i}-filter`}
                  type='checkbox'
                  className={classes.filterInput}
                  onClick={() => onFilterItems(category, i)}
                  disabled={disabled}
                  aria-label={i}
                />
                <FontIcon
                  icon={selectedItems.indexOf(i) !== -1 ? 'fas fa-check-square' : 'far fa-square'}
                  className={classes.filterIcon}
                />
                <div className={classes.filterItem} dangerouslySetInnerHTML={{ __html: `${i} (${items[i] || 0})` }} />
              </label>
            </div>;
        })}
        {Object.keys(items).length > showMoreItems &&
          <button
            aria-label={showMore ? 'Show Less' : 'Show More'}
            className={classes.showMoreContainer}
            onClick={this.toggleShowMore}
            type='button'
          >
            Show { showMore ? 'Less' : 'More' }
            <FontIcon
              className={classes.showMoreIcon}
              icon={`far ${showMore ? 'fa-chevron-up' : 'fa-chevron-down'}`}
            />
          </button>}
      </div>
    );
  }
}

ProductFilterA.propTypes = {
  items: PropTypes.object.isRequired,
  selectedItems: PropTypes.array,
  title: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  showMoreItems: PropTypes.number,
  onFilterItems: PropTypes.func.isRequired,
};

export default ProductFilterA;
